export default __webpack_public_path__ + "static/media/exclusive-tour.ca969329.glb";